import { Link } from 'react-router-dom';
import '../scss/components/NotFound.scss';
import React from 'react';

const NotFound = () => {
  return (
    <>
      <div>
        <h1 className='no-select'>Not Found!</h1>
        <Link to='/'>Go Home</Link>
      </div>
    </>
  );
};

export default NotFound;
